import type { CopilotCommandCenterGenericMenuItemProps } from './components/MenuItems/CopilotCommandCenterGenericMenuItem';
import type { CopilotCommandCenterSettingsProps } from './components/MenuItems/CopilotCommandCenterSettings';
import type { CopilotCommandCenterChatProps } from './components/MenuItems/CopilotCommandCenterChat';
import type { CopilotPrioritizeFreContentProps } from './components/CopilotPrioritizeFre/CopilotPrioritizeFre';
import type { CopilotCommandCenterProps } from './components/CopilotCommandCenter';
import type * as lazyIndex from './lazyIndex';
import { type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotCommandCenter" */ './lazyIndex'),
    { name: 'CopilotCommandCenter' }
);

export const CopilotCommandCenter: LazyComponent<CopilotCommandCenterProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotCommandCenter);
export const CopilotPrioritizeFreContent: LazyComponent<
    CopilotPrioritizeFreContentProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.CopilotPrioritizeFreContent);
export { OptInResult } from './store/types/CopilotCommandCenterPrioritizeData';
export const CopilotCommandCenterChat: LazyComponent<CopilotCommandCenterChatProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotCommandCenterChat);
export const CopilotCommandCenterSettings: LazyComponent<
    CopilotCommandCenterSettingsProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.CopilotCommandCenterSettings);
export const CopilotCommandCenterGenericMenuItem: LazyComponent<
    CopilotCommandCenterGenericMenuItemProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.CopilotCommandCenterGenericMenuItem);
